import * as React from "react";
import { cn } from "../../lib/utils";

export interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  error?: boolean;
}

const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, error, children, ...props }, ref) => {
    return (
      <div className="relative inline-flex items-center">
        <select
          ref={ref}
          className={cn(
            // Match Input.tsx height and general look & feel
            "flex h-10 w-fit rounded-none border bg-white p-2 pr-5 text-sm disabled:cursor-not-allowed disabled:bg-disabled-bg disabled:opacity-100 transition-all appearance-none",
            // Default normal vs error styles — remove extra focus ring, just change border color
            error
              ? "border-red-500 focus:outline-none focus:border-red-500"
              : "border-border-gray hover:border-gray-400 focus:outline-none focus:border-primary-blue",
            // Reserve space for the custom chevrons on the right
            className
          )}
          {...props}
        >
          {children}
        </select>
        {/* Custom up/down chevrons, positioned like native caret */}
        <svg
          aria-hidden="true"
          className="pointer-events-none absolute right-2 h-4 w-4 text-primary-blue"
          viewBox="0 0 24 24"
          fill="currentColor"
          focusable="false"
        >
          <path d="M7 10l5-5 5 5H7z" />
          <path d="M7 14l5 5 5-5H7z" />
        </svg>
      </div>
    );
  }
);

Select.displayName = "Select";

export { Select };
